export const getSelectionOptionStorageKey = (id: string) => {
  return `catalog/products/${id}?selection-option`;
};
